import { FC } from "react";
import { Tweet } from "react-tweet";

interface Props {
  url: string;
}

export const EmbedTweet: FC<Props> = ({ url }) => {
  const id = new URL(url).pathname.split("/").pop() ?? "";

  return <Tweet id={id}></Tweet>;
};
